import DescriptionStep from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionStep.vue';
import StrategyPrivacyStep from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/StrategyPrivacyStep.vue';
import ApplicationSubmitStep from '@/profile-creation-wizard/components/for-completion/ui/application-submit/ApplicationSubmitStep.vue';
import LinkedImportStep from '@/profile-creation-wizard/components/for-completion/ui/linkedin-import/LinkedInImportStep.vue';
import YourEducationStep from '@/profile-creation-wizard/components/for-completion/ui/your-education/YourEducationStep.vue';
import YourExperienceStep from '@/profile-creation-wizard/components/for-completion/ui/your-experience/YourExperienceStep.vue';
import StrategyHeadlineStep from '@/profile-creation-wizard/components/for-creation/ui/1_headline/StrategyHeadlineStep.vue';
import CategorizationStep from '@/profile-creation-wizard/components/for-creation/ui/2_categorization/CategorizationStep.vue';
import LocalisationDetails from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationStep.vue';
import DailyRateStep from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/DailyRateStep.vue';
import MaltStrategyFunctionalSkillsStep from '@/profile-creation-wizard/components/for-creation/ui/functionalSkills/MaltStrategyFunctionalSkillsStep.vue';
import IndustryExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/industrySkills/IndustryExpertiseStep.vue';
import IntroductionStep from '@/profile-creation-wizard/components/for-creation/ui/introduction/IntroductionStep.vue';
import UseCaseStep from '@/profile-creation-wizard/components/for-creation/ui/useCase/UseCaseStep.vue';
import {
    CreationStepName,
    MaltStrategyStepTrackingName,
    ProfileCreationStepGroup,
    ProfileCreationSteps,
} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import WaitingRoom from '@/profile-creation-wizard/components/waiting-room/WaitingRoom.vue';
import {MaltStrategyCreationStepRoute} from '@/profile-creation-wizard/config/steps/ProfileCreationRoutes';

export enum MaltStrategyCreationStepNumber {
    SIGNUP_INTRODUCTION = 1,
    SIGNUP_USE_CASE,
    SIGNUP_HEADLINE,
    SIGNUP_CATEGORIZATION,
    SIGNUP_EXPERTISE,
    SIGNUP_INDUSTRY_EXPERTISE,
    SIGNUP_DAILY_RATE,
    SIGNUP_LOCALISATION,
    COMPLETION_LINKEDIN,
    COMPLETION_EXPERIENCE,
    COMPLETION_EDUCATION,
    COMPLETION_DESCRIPTION,
    COMPLETION_PRIVACY,
    COMPLETION_SUBMIT_APPLICATION,
}

export enum WaitingRoomStepNumber {
    WAITING_ROOM = 1,
}

const totalCreationSteps = Object.entries(MaltStrategyCreationStepNumber).length / 2;
const totalWaitingRoomSteps = Object.entries(WaitingRoomStepNumber).length;

export const maltStrategyCreationSteps: ProfileCreationSteps = [
    {
        name: CreationStepName.SIGNUP_INTRODUCTION,
        route: MaltStrategyCreationStepRoute.SIGNUP_INTRODUCTION,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_INTRODUCTION,
        stepCount: totalCreationSteps,
        previousStepName: null,
        nextStepName: CreationStepName.SIGNUP_USE_CASE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: IntroductionStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_INTRODUCTION,
    },
    {
        name: CreationStepName.SIGNUP_USE_CASE,
        route: MaltStrategyCreationStepRoute.SIGNUP_USE_CASE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_USE_CASE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_INTRODUCTION,
        nextStepName: CreationStepName.SIGNUP_HEADLINE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: UseCaseStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_USE_CASE,
    },
    {
        name: CreationStepName.SIGNUP_HEADLINE,
        route: MaltStrategyCreationStepRoute.SIGNUP_HEADLINE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_HEADLINE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_USE_CASE,
        nextStepName: CreationStepName.SIGNUP_CATEGORIZATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: StrategyHeadlineStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_HEADLINE,
    },
    {
        name: CreationStepName.SIGNUP_CATEGORIZATION,
        route: MaltStrategyCreationStepRoute.SIGNUP_CATEGORIZATION,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_CATEGORIZATION,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_HEADLINE,
        nextStepName: CreationStepName.SIGNUP_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: CategorizationStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_CATEGORIZATION,
    },
    {
        name: CreationStepName.SIGNUP_EXPERTISE,
        route: MaltStrategyCreationStepRoute.SIGNUP_EXPERTISE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_EXPERTISE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_CATEGORIZATION,
        nextStepName: CreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: MaltStrategyFunctionalSkillsStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_EXPERTISE,
    },
    {
        name: CreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        route: MaltStrategyCreationStepRoute.SIGNUP_INDUSTRY_EXPERTISE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_INDUSTRY_EXPERTISE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_EXPERTISE,
        nextStepName: CreationStepName.SIGNUP_DAILY_RATE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: IndustryExpertiseStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_INDUSTRY_EXPERTISE,
    },
    {
        name: CreationStepName.SIGNUP_DAILY_RATE,
        route: MaltStrategyCreationStepRoute.SIGNUP_DAILY_RATE,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_DAILY_RATE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        nextStepName: CreationStepName.SIGNUP_LOCALISATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: DailyRateStep,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_DAILY_RATE,
    },
    {
        name: CreationStepName.SIGNUP_LOCALISATION,
        route: MaltStrategyCreationStepRoute.SIGNUP_LOCALISATION,
        stepNumber: MaltStrategyCreationStepNumber.SIGNUP_LOCALISATION,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.SIGNUP_DAILY_RATE,
        nextStepName: CreationStepName.COMPLETION_LINKEDIN, // signup
        group: ProfileCreationStepGroup.SIGNUP,
        component: LocalisationDetails,
        trackingName: MaltStrategyStepTrackingName.SIGNUP_LOCALISATION,
    },
    // Completion
    {
        name: CreationStepName.COMPLETION_LINKEDIN,
        route: MaltStrategyCreationStepRoute.COMPLETION_LINKEDIN,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_LINKEDIN,
        stepCount: totalCreationSteps,
        previousStepName: null, // signup
        nextStepName: CreationStepName.COMPLETION_EXPERIENCE,
        group: ProfileCreationStepGroup.COMPLETION,
        component: LinkedImportStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_LINKEDIN,
    },
    {
        name: CreationStepName.COMPLETION_EXPERIENCE,
        route: MaltStrategyCreationStepRoute.COMPLETION_EXPERIENCE,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_EXPERIENCE,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.COMPLETION_LINKEDIN,
        nextStepName: CreationStepName.COMPLETION_EDUCATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: YourExperienceStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_EXPERIENCE,
    },
    {
        name: CreationStepName.COMPLETION_EDUCATION,
        route: MaltStrategyCreationStepRoute.COMPLETION_EDUCATION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_EDUCATION,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.COMPLETION_EXPERIENCE,
        nextStepName: CreationStepName.COMPLETION_DESCRIPTION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: YourEducationStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_EDUCATION,
    },
    {
        name: CreationStepName.COMPLETION_DESCRIPTION,
        route: MaltStrategyCreationStepRoute.COMPLETION_DESCRIPTION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_DESCRIPTION,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.COMPLETION_EDUCATION,
        nextStepName: CreationStepName.COMPLETION_PRIVACY,
        group: ProfileCreationStepGroup.COMPLETION,
        component: DescriptionStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_DESCRIPTION,
    },
    {
        name: CreationStepName.COMPLETION_PRIVACY,
        route: MaltStrategyCreationStepRoute.COMPLETION_PRIVACY,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_PRIVACY,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.COMPLETION_DESCRIPTION,
        nextStepName: CreationStepName.COMPLETION_SUBMIT_APPLICATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: StrategyPrivacyStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_PRIVACY,
    },
    {
        name: CreationStepName.COMPLETION_SUBMIT_APPLICATION,
        route: MaltStrategyCreationStepRoute.COMPLETION_SUBMIT_APPLICATION,
        stepNumber: MaltStrategyCreationStepNumber.COMPLETION_SUBMIT_APPLICATION,
        stepCount: totalCreationSteps,
        previousStepName: CreationStepName.COMPLETION_PRIVACY,
        nextStepName: null,
        group: ProfileCreationStepGroup.COMPLETION,
        component: ApplicationSubmitStep,
        trackingName: MaltStrategyStepTrackingName.COMPLETION_SUBMIT_APPLICATION,
    },
    // Waiting room
    {
        name: CreationStepName.WAITING_ROOM,
        route: MaltStrategyCreationStepRoute.WAITING_ROOM,
        stepNumber: WaitingRoomStepNumber.WAITING_ROOM,
        stepCount: totalWaitingRoomSteps,
        previousStepName: null,
        nextStepName: null,
        group: ProfileCreationStepGroup.WAITING_ROOM,
        component: WaitingRoom,
        trackingName: '',
    },
];
